<template>
  <div>
    <LeadDetails 
      @closeDialog="closeLeadDialog"  
      :dialog="leadDialog"
      :lead="selectedLead"/>
    <v-dialog
    <v-data-table
      :headers="headers"
      :items="$store.state.leads.data"
      hide-default-footer
      class="elevation-1"      
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',        
      }"                
    >      
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{item.name}}</td>
            <td>{{item.email}}</td>
            <td>
              <v-btn fab small color="secondary" @click="() => showLeadDialog(item)">
                <v-icon>search</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>    
    <div class="text-xs-center ">
      <v-pagination @input="changePage" v-model="pagination.page" :length="pages"></v-pagination>
    </div>
  </div> 
</template>

<script>
  import LeadDetails from '../Leads/Details.vue'
  export default {
    components: {
      LeadDetails
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
    },
    name: 'List',    
    data () {
      return {
        selectedLead: null,
        leadDialog: false,
        search: '',
        search_timeout: null,
        headers: [
          {text: 'Nome', value: 'name'},
          {text: 'Email', value: 'email'},          
          {text: '', value: ''},
        ],
        pagination: {
          descending: false,
          page: this.$store.state.leads.current_page,
          rowsPerPage: this.$store.state.leads.per_page,
          sortBy: '',
          totalItems: this.$store.state.leads.total
        }
      }
    },
    computed: {
      pages () {
        if (this.$store.state.leads.total === 0) {
          return 0;
        }
        return Math.ceil(this.$store.state.leads.total / this.$store.state.leads.per_page)
      },
      sDialog: {
        get() {
          return this.dialog;
        },
        set(value) {          
          this.$emit('closeDialog');
        }
      },
    },
    created() {
      this.fetchLeads();
    },
    methods: {
      fetchLeads() {
        this.$store.dispatch('fetchLeads');
      },
      showLeadDialog(lead) {
        this.selectedLead = lead
        this.leadDialog = true
      },
      closeLeadDialog() {
        this.leadDialog = false
      },
      changePage(page) {
        this.$store.dispatch('setLeadsPage', page);
        this.fetchLeads();
      }
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchLeads',
      /*'search'(newVal, oldVal) {
        if (this.search_timeout) {
            clearTimeout(this.search_timeout);
        }
        const self = this;
        this.search_timeout = setTimeout( () => { 
          this.$store.dispatch('setTransactionsQuery', newVal);
          this.fetchTransactions();
        }, 600);
      }*/
    },
  }
</script>